import styled from 'styled-components';
import LinkHandler from '../link-handler';
import { linkOnDarkBgStyles } from '../styled/links';

export const Wrapper = styled.section`
  padding: ${({ theme }) => theme.spacing.standard} 0;
  background-color: ${({ theme }) => theme.palette.darkBackground};
  margin-bottom: ${({ $removeMarginBottom, sidebar, theme }) =>
    ($removeMarginBottom && '0') ||
    (sidebar && theme.spacing.standard) ||
    theme.spacing.large};
`;

export const Header = styled.h2`
  color: ${({ theme }) => theme.palette.white};
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.small};
`;

export const StyledLinkHandler = styled(LinkHandler)`
  color: ${({ theme }) => theme.palette.white};
  ${linkOnDarkBgStyles}
`;
